import { tx } from "@/i18n/tx";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Allega SEMPRE la lingua attiva alle richieste: la lingua che l'utente vede
// determina i contenuti dinamici (simboli, domande, riflessioni, AI). Evita che
// una preferenza di profilo rimasta indietro mostri testi in un'altra lingua.
const SUPPORTED = ["it", "en", "fr", "es", "de"];
api.interceptors.request.use((config) => {
  try {
    let lang = (localStorage.getItem("anima_lang") || "it").slice(0, 2);
    if (!SUPPORTED.includes(lang)) lang = "it";
    config.params = { ...(config.params || {}), lang };
  } catch (e) { /* localStorage non disponibile */ }
  return config;
});

export function formatError(detail) {
  if (detail == null) return tx("Qualcosa non ha funzionato. Riprova.");
  if (typeof detail === "string") return tx(detail);
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
